const FeesBanner = ({bannerData}) => {
  return (
    <div className="section__fees-banner">
      <h1>{bannerData.bannerTitle}</h1>
      <p className="subtitle_1">{bannerData.bannerDescription}</p>
      <div className="section__fees-banner__image" style={{ backgroundImage: `url(${bannerData?.bannerImage?.sourceUrl})` }} />
    </div>
  );
};

export default FeesBanner;
